export const formatDefaultValue = (defaultValue: string) => {
  try {
    return JSON.stringify(JSON.parse(defaultValue), null, 2);
  } catch {
    return defaultValue;
  }
};

/** Multi-line or nested object types render as formatted code instead of a tag. */
export const isComplexObjectType = (type: string): boolean => {
  if (type.includes("\n")) {
    return true;
  }

  const objectCount = (type.match(/object\(/g) || []).length;
  return objectCount > 1;
};
